module.exports = __webpack_public_path__ + "media/newstyle/images/stars_1-orange-4ff319d78424d2b2a7477fb309f749cb.svg";